DO.Subscribe(['app:ready'], () => {
  document.addEventListener(
    'click',
    (event) => {
      if (event.target.hasAttribute('data-expand')) {
        const targetRef = event.target.getAttribute('data-expand');
        let targetElem = event.target.closest(targetRef);

        if (
          event.target.classList.contains(
            'element-snapshot--accordion__heading',
          )
        ) {
          const parent = event.target.closest(targetRef);
          parent.classList.toggle('active');
          targetElem = event.target;
        }

        if (targetElem) {
          const expanded = targetElem.getAttribute('aria-expanded') === 'true';
          targetElem.setAttribute('aria-expanded', !expanded);
        }
      }
    },
    false,
  );
});
